import {
  Alert, Button, Divider,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow, TextField,
  Typography,
} from "@mui/material";
import { ResponsiveRow } from "../../../../constants/layout.constants";
import ModalContainerModule from "../../../modules/modalContainer";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  DetailsColumn,
  DetailsContainer, DetailsLabel,
  DetailsRow, DetailsText,
  ModalAcceptButton
} from "../../../../constants/component.constants";
import {
  formatCurrency,
  formatDate, getRefNumber,
  isArray,
  isEmptyString,
  isNullUndefined,
  isValidDate,
  tryParseFloat
} from "../../../../util/util";
import dayjs from "dayjs";
import MuiDataGrid from "../../../modules/MuiDataGrid";
import { Container } from "@mui/system";
import {useEffect, useMemo, useState} from "react";
import {orgBankAccounts} from "../../../../services/bank.service";
import {
  getBankAccountTransactionDetailsNotReconciledBefore,
  getReconciliationStartDate,
} from "../../../../services/reconciliation.service";
import {ledgerAccForBank} from "../../../../services/list.service";
import {issueWarnMessage} from "../../../../actions/message";
import {Cancel} from "@mui/icons-material";

export default function CreateReconciliationModal(props) {
  const [selectionModel, setSelectionModel] = useState([]);
  const [chargeInterestItems, setChargeInterestItems] = useState([]);
  const [showItemApplyToOptions, setShowItemApplyToOptions] = useState(true);
  const [items, setItems] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [statementDate, setStatementDate] = useState(new Date());
  const [begBalance, setBegBalance] = useState("");
  const [endBalance, setEndBalance] = useState("");
  const [itemTypeOptions] = useState([
    { label: 'Bank Charge', value: 'charge' }, { label: 'Interest', value: 'interest' }
  ]);
  const [itemApplyToOptions, setItemApplyToOptions] = useState([]);
  const [previousSelectedTransactions, setPreviousSelectedTransactions] = useState([]);
  const [reconciledTransactionDetails, setReconciledTransactionDetails] = useState([]);
  const [reconciledTransactionDetailsTotal, setReconciledTransactionDetailsTotal] = useState(0);
  const [isNewReconciliation, setIsNewReconciliation] = useState(false);
  const [selectedBankAcc, setSelectedBankAcc] = useState("");
  const [step, setStep] = useState(1);
  const [unreconciledTransactions, setUnreconciledTransactions] = useState([]);
  const [orgBankAccountsList, setOrgBankAccountsList] = useState([]);


  const reconBalance = useMemo(() => {
    let tempReconBalance = 0;
    selectionModel.forEach(id => {
      const transaction = unreconciledTransactions.find(t => t.id === id);
      if(transaction.type === "Receipt"){
        tempReconBalance += parseFloat(transaction.amount);
      }else{
        tempReconBalance -= parseFloat(transaction.amount);
      }
    });

    items.forEach(item => {
      if (item.type === "charge") {
        tempReconBalance -= parseFloat(item.amount);
      } else if (item.type === "interest") {
        tempReconBalance += parseFloat(item.amount);
      }
    });
    tempReconBalance += parseFloat(begBalance);
    return tempReconBalance;
  }, [selectionModel, begBalance, items, unreconciledTransactions])

  const balanceDiff = useMemo(() => {
    return parseFloat(endBalance) - parseFloat(reconBalance);
  }, [endBalance, reconBalance])


  useEffect(() => {
    props.setLoading(true);
    orgBankAccounts()
        .then((data) => setOrgBankAccountsList(data))
        .finally(() => {props.setLoading(false)});
  }, []);


  useEffect(() => {
    let chargeInterestItemsOpt = [];
    if (itemApplyToOptions.length === 1) {
      setShowItemApplyToOptions(false);
    }
    items &&
    items.length > 0 &&
    (chargeInterestItemsOpt = items.map(function (chargeInterestItem, i) {
      return (
          <TableRow key={i}>
            <TableCell>
              <Select
                  sx={{ width: '90%' }}
                  id={'type' + i}
                  placeholder="Select type Interest/Charge"
                  value={chargeInterestItem.type}
                  onChange={(event) => itemTypeChanged(event, i)}
              >
                {itemTypeOptions && itemTypeOptions.length > 0 ? (
                    itemTypeOptions.map(function (item, i) {
                      return (
                          <MenuItem key={i} value={item.value}>
                            {item.label}
                          </MenuItem>
                      );
                    }, this)
                ) : (
                    <MenuItem sx={{ width: '100%' }}>No Results Found</MenuItem>
                )}
              </Select>
            </TableCell>

            {showItemApplyToOptions && !isEmptyString(selectedBankAcc) && (
                <TableCell>
                  <Select
                      sx={{ width: '90%' }}
                      id={'applyTo' + i}
                      placeholder="Account To Apply"
                      value={chargeInterestItem.applyTo}
                      onChange={(event) => accountToApplyToChanged(event, i)}
                  >
                    {itemApplyToOptions && itemApplyToOptions.length > 0 ? (
                        itemApplyToOptions.map(function (item, i) {
                          return (
                              <MenuItem key={item.value} value={item.value}>
                                {item.label}
                              </MenuItem>
                          );
                        }, this)
                    ) : (
                        <MenuItem sx={{ width: '100%' }}>No Results Found</MenuItem>
                    )}
                  </Select>
                </TableCell>
            )}

            <TableCell>
              <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale="en-gb"
              >
                <DatePicker
                    sx={{ width: '90%' }}
                    id={'date'}
                    value={dayjs(chargeInterestItem.itemDate)}
                    onChange={(newDate) => interestChargeDateChanged(newDate, i)}
                />
              </LocalizationProvider>
            </TableCell>

            <TableCell>
              <TextField
                  placeholder={'Amount'}
                  sx={{ width: '90%' }}
                  id={'amount'}
                  onChange={(event) => {
                    interestChargeAmountChanged(event, i);
                  }}
                  value={chargeInterestItem.amount}
              />
            </TableCell>

            <TableCell>
              <Button
                  variant="contained"
                  type="button"
                  sx={{ marginLeft: '10px' }}
                  onClick={() => chargeInterestItemDelete(i)}
                  color="error"
              >
                <Cancel />
              </Button>
            </TableCell>
          </TableRow>
      );
    }));
    setChargeInterestItems(chargeInterestItemsOpt)
  }, [items, itemApplyToOptions])


  useEffect(() => {
    if(previousSelectedTransactions.length > 1 && selectionModel.length < 1) {
      setSelectionModel(previousSelectedTransactions);
    }else if(previousSelectedTransactions.length > 0 && selectionModel.length > 0) {
      setPreviousSelectedTransactions(selectionModel);
    }
  }, [previousSelectedTransactions, selectionModel]);


  function isStartDateRangeInvalid() {
    if (isValidDate(startDate) && isValidDate(statementDate)) {
      return dayjs(startDate).startOf("day").isAfter(dayjs(statementDate).startOf("day"));
    }
    return false;
  }

  function isReconciliationFormValid() {
    if (!isValidDate(statementDate)) {
      issueWarnMessage("Statement date entered is not a valid date.")
      return false;
    }
    if (!isValidDate(startDate)) {
      issueWarnMessage("Start date entered is not a valid date.")
      return false;
    }
    if (
        isNullUndefined(selectedBankAcc) ||
        isEmptyString(selectedBankAcc)
    ) {
      issueWarnMessage("Select a bank account before proceeding with reconciliation.")
      return false;
    }
    if (startDate > statementDate) {
      issueWarnMessage("Start Date cannot be greater than Statement Date.")
      return false;
    }
    let tryBegBalance = tryParseFloat(begBalance, -1);
    if (tryBegBalance < 1) {
      issueWarnMessage("Invalid beginning balance. The beginning balance entered must be more than KSH 0")
      return false;
    }
    setBegBalance(tryBegBalance);
    let tryEndBalance = tryParseFloat(endBalance, -1);
    if (tryEndBalance < 1) {
      issueWarnMessage("Invalid ending balance. The ending balance entered must be more than KSH 0")
      return false;
    }
    setEndBalance(tryEndBalance);
    if (!isNullUndefined(items) && items.length > 0) {

      for(let i=0; i < items.length; i++) {
        let chargeInterestItem = items[i];
        if ( chargeInterestItem.itemDate > statementDate) {
          issueWarnMessage("Charge/Interest item Date cannot be greater than Statement Date.");
          return false;
        }
        if ( chargeInterestItem.itemDate < startDate) {
          issueWarnMessage("Charge/Interest item Date cannot be before Start Date.");
          return false;
        }
        let amount = tryParseFloat(chargeInterestItem.amount, -1);
        if (
            amount < 1 ||
            isEmptyString(chargeInterestItem.amount) ||
            isNullUndefined(chargeInterestItem.amount)
        ) {
          issueWarnMessage("Enter valid amount value.");
          return false;
        }
        if (!isValidDate(chargeInterestItem.itemDate)) {
          issueWarnMessage("Charge/Interest item invalid date selected.");
          return false;
        }

        if (
            isNullUndefined(chargeInterestItem.type) ||
            isEmptyString(chargeInterestItem.type)
        ) {
          issueWarnMessage("Please select item type");
          return false;
        }
      };
    }

    return true;
  }

  function addChargeOrInterestItem() {
    let itemApplyTo = '';
    let data = {};
    if (itemApplyToOptions.length === 1) {
      itemApplyTo = itemApplyToOptions[0].value;
      data = {
        id: null,
        type: null,
        itemDate: statementDate,
        applyTo: itemApplyTo,
        amount: null,
      };
    } else {
      data = {
        id: null,
        type: null,
        itemDate: statementDate,
        applyTo: null,
        amount: null,
      };
    }

    setItems((values) => [...values, data]);
  }

  function chargeInterestItemDelete(index) {
    let itemsArray = [...items]; // copying the old items array
    itemsArray.splice(index, 1);
    setItems(itemsArray);
  }

  function itemTypeChanged(event, index) {
    let value = event.target.value;
    let itemsArray = [...items]; // copying the old items array
    itemsArray[index].type = value;
    setItems(itemsArray);
  }

  function accountToApplyToChanged(event, index) {
    let value = event.target.value;
    let itemsArray = [...items]; // copying the old items array
    itemsArray[index].applyTo = value;
    setItems(itemsArray);
  }

  function interestChargeAmountChanged(event, index) {
    let value = event.target.value;
    let itemsArray = [...items]; // copying the old items array
    itemsArray[index].amount = value;
    setItems(itemsArray);
  }

  function interestChargeDateChanged(dateValue, index) {
    let date = new Date(dateValue);
    let itemsArray = [...items]; // copying the old items array
    itemsArray[index].itemDate = date;
    setItems(itemsArray);
  }

  function handleSaveReconciliation() {
    if (selectionModel.length < 1) {
      issueWarnMessage("You must reconcile at least one bank transaction to save this reconciliation.")
      return false;
    }
    let data = {
      accountId: selectedBankAcc,
      startDate: startDate,
      statementDate: statementDate,
      referenceNumber: getRefNumber(),
      begBalance: begBalance,
      endBalance: endBalance,
      reconBalance: reconBalance,
      balanceDiff: balanceDiff,
      bankTransactionSet: selectionModel.map((id) => unreconciledTransactions.find((item) => item.id === id)?.transactionId),
      items: items,
    };
    props.saveReconciliation(data)

  }

  function handleProceedClicked() {
    if (isReconciliationFormValid()) {
      if(step === 2){
        props.setLoading(true)
        setStep(3)
        setPreviousSelectedTransactions(selectionModel);
        const selectedIds = new Set(selectionModel);
        const selectedUnreconciledTransactions = unreconciledTransactions.filter(obj => selectedIds.has(obj.id))
        let data = []
        items.forEach((item, index) => {
          let debitAmount = 0.00
          let	creditAmount = 0.00
          let description = ""
          let type = ""
          if(item.type === "interest"){
            description = "Reconciliation (Bank interest earned)"
            creditAmount = item.amount
            type = "Interest"

          }else{
            description = "Reconciliation (Bank charges incurred)"
            debitAmount = item.amount
            type = "Charge"
          }
          data.push({
            id: index + 1,
            type: type,
            description: description,
            debitAmount: debitAmount,
            creditAmount: creditAmount,
            entryDate: new Date(item.itemDate),
          })
        });
        selectedUnreconciledTransactions.forEach(item => {
          let debitAmount = 0.00
          let	creditAmount = 0.00
          if(item.type === "Receipt"){
            creditAmount = item.amount

          }else{
            debitAmount = item.amount
          }
          data.push({
            id: item.id,
            type: item.type,
            description: item.description,
            debitAmount: debitAmount,
            creditAmount: creditAmount,
            entryDate: new Date(item.date),
          })
        });
        setReconciledTransactionDetails(data.sort((a, b) => a.entryDate - b.entryDate));
        setReconciledTransactionDetailsTotal(data.length);
        props.setLoading(false)
      }

      if(step === 1){
        props.setLoading(true)
        getBankAccountTransactionDetailsNotReconciledBefore(
            selectedBankAcc,
            startDate,
            statementDate
        )
            .then((data) => {
              setStep(2)
              setUnreconciledTransactions(data)
              if(previousSelectedTransactions.length > 0) {
                const includeIds = new Set(data.map(obj => obj.id));
                const filteredResult = previousSelectedTransactions.filter(id => includeIds.has(id));
                setPreviousSelectedTransactions(filteredResult);
                setSelectionModel(filteredResult);
              }
            }).finally(() => props.setLoading(false));
      }
    }
  }

  function handleBackButtonClicked() {
    if(step === 2){
      setPreviousSelectedTransactions(selectionModel);
    }
    if(step === 3){
      setSelectionModel(previousSelectedTransactions);
    }
    let currentStep = step
    if(currentStep > 1){
      currentStep -= 1
      setStep(currentStep)
    }
  }

  function handleBankAccountChanged(event) {
    let value = event.target.value;
    setSelectionModel([]);
    setPreviousSelectedTransactions([])
    setSelectedBankAcc(value)
    ledgerAccForBank(value)
        .then((data) => setItemApplyToOptions(data))
    getReconciliationStartDate(value)
        .then((data) => {
          if(data.begBalance > 0){
            setBegBalance(data.begBalance)
          }
          setIsNewReconciliation(data.isNewReconciliation);
          setStartDate(new Date(data.startDate));
        })
  }

  const bankTransactionColumns = [
    {
      headerName: 'Date',
      field: 'date',
      minWidth: 100,
      flex: 1,
      valueFormatter: (row) => {
        return formatDate(row.value);
      },
    },
    { headerName: 'Type', field: 'type', minWidth: 140, flex: 1 },
    { headerName: 'Payment Method', field: 'paymentMethod', minWidth: 100, flex: 1 },
    { headerName: 'Cheque No/ Bank Ref No.', field: 'chequeNumber', minWidth: 150, flex: 1.1 },
    { headerName: 'Ref/Applied To', field: 'referenceNumber', minWidth: 150, flex: 1 },
    { headerName: 'Description', field: 'description', minWidth: 200, flex: 1.5 },
    {
      headerName: 'Debit Amount',
      field: 'debitAmount',
      minWidth: 120,
      flex: 1,
      valueFormatter: (row) => {
        return formatCurrency(row.value);
      },
    },
    {
      headerName: 'Credit Amount',
      field: 'creditAmount',
      minWidth: 120,
      flex: 1,
      valueFormatter: (row) => {
        return formatCurrency(row.value);
      },
    },
  ];

  return (
    <ModalContainerModule
      size="lg"
      accept={step < 3 ? handleProceedClicked : handleSaveReconciliation}
      cancel={props.handleCloseReconciliationClicked}
      openModal={props.reconciliationForm}
      modalTitle={" Reconciliation "}
      acceptButtonText={step === 1 ? "Proceed/Continue" : step === 2 ? "Preview/Confirm" : "Reconcile"}
      cancel2={step > 1}
      cancel2Text={"Back"}
      handleCancel2={handleBackButtonClicked}
      cancelDisabled2={step === 1 }
      acceptLoading={props.loading}
    >
      {step === 1 && (
        <ResponsiveRow container sx={{ height: "auto", justifyContent: { xs: "center", lg: "start"} }}>
          <Alert
            id="reconciliationForm"
            severity="info"
            icon={false}
            sx={{ width: "100%", marginBottom: "15px" }}
          >
            Select an account to reconcile and then enter the ending balance from
            your account statement.
          </Alert>
          <br />

          <FormControl
            item
            sx={{ width: { xs: "100%", lg: "33.3%" }, marginBottom: "10px" }}
          >
            <InputLabel>Select Account</InputLabel>
            <Select
              label="Select Account"
              sx={{ width: { xs: "100%", lg: "90%" } }}
              id={"bankAccount"}
              value={selectedBankAcc}
              onChange={(event) => {
                handleBankAccountChanged(event);
              }}
            >
              {orgBankAccountsList &&
              orgBankAccountsList.length > 0 ? (
                orgBankAccountsList.map(function (idType, i) {
                  return (
                    <MenuItem key={i} value={idType.value}>
                      {idType.label}
                    </MenuItem>
                  );
                }, this)
              ) : (
                <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
              )}
            </Select>
          </FormControl>

          <FormControl
            item
            sx={{ width: { xs: "100%", lg: "33.3%" }, marginBottom: "10px" }}
          >
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="en-gb"
            >
              <DatePicker
                label="Start Date"
                sx={{ width: { xs: "100%", lg: "90%" } }}
                id={"startDate"}
                value={dayjs(startDate)}
                slotProps={{
                  textField: {
                    error: isStartDateRangeInvalid(),
                    helperText: isStartDateRangeInvalid()
                        ? "Start Date must be before Statement Date"
                        : "",
                  },
                }}
                disabled={!isNewReconciliation}
                onChange={(newDate) => {
                  let date = new Date(newDate);
                  setStartDate(date);
                }}
              />
            </LocalizationProvider>
          </FormControl>

          <FormControl
            item
            sx={{ width: { xs: "100%", lg: "33.3%" }, marginBottom: "10px" }}
          >
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="en-gb"
            >
              <DatePicker
                label="Statement Date"
                sx={{ width: { xs: "100%", lg: "90%" } }}
                id={"statementDate"}
                value={dayjs(statementDate)}
                onChange={(newDate) => {
                  let date = new Date(newDate);
                  setStatementDate(date);
                }}
              />
            </LocalizationProvider>
          </FormControl>

          <FormControl
            item
            sx={{ width: { xs: "100%", lg: "33.3%" }, marginBottom: "10px" }}
          >
            <InputLabel>Beginning Balance</InputLabel>
            <OutlinedInput
              label="Beginning Balance"
              placeholder={"Beginning Balance (KSH)"}
              sx={{ width: { xs: "100%", lg: "90%" } }}
              id={"begBalance"}
              onChange={(event) => {
                let value = event.target.value;
                setBegBalance(value);
              }}
              value={begBalance}
            />
          </FormControl>

          <FormControl
            item
            sx={{ width: { xs: "100%", lg: "33.3%" }, marginBottom: "10px" }}
          >
            <InputLabel>Ending Balance</InputLabel>
            <OutlinedInput
              label="Ending Balance"
              placeholder={"Ending Balance (KSH)"}
              sx={{ width: { xs: "100%", lg: "90%" } }}
              id={"endBalance"}
              onChange={(event) => {
                let value = event.target.value;
                setEndBalance(value);
              }}
              value={endBalance}
            />
          </FormControl>

          <Typography
            sx={{ width: "100%", margin: "20px auto" }}
            id="reconciliation"
            variant="h5"
            component="h6"
          >
            Add any bank service charge or interest earned
          </Typography>
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "20%" }}>Type</TableCell>
                  {showItemApplyToOptions &&
                    !isEmptyString(selectedBankAcc) && (
                      <TableCell sx={{ width: "20%" }}>Expense Account</TableCell>
                    )}
                  <TableCell sx={{ width: "20%" }}>Date</TableCell>
                  <TableCell sx={{ width: "20%" }}>Amount</TableCell>
                  <TableCell sx={{ width: "5%" }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{chargeInterestItems}</TableBody>
            </Table>
          </TableContainer>
          <ResponsiveRow
            sx={{
              width: "100%",
              justifyContent: { xs: "center", lg: "flex-end" },
              marginTop: "20px",
            }}
          >
            <ModalAcceptButton
              variant="contained"
              type="submit"
              onClick={() => addChargeOrInterestItem()}
              sx={{
                width: { xs: "100%", lg: "200px" },
              }}
            >
              Add Row
            </ModalAcceptButton>
          </ResponsiveRow>
        </ResponsiveRow>
      )}
      {step === 2 && (
        <ResponsiveRow container sx={{ height: "auto", justifyContent: "start", paddingBlock: "0px"}}>
          <Alert
            id="reconciliationForm"
            severity="info"
            icon={false}
            sx={{ width: "100%"}}
          >
            Select transactions to reconcile and click the preview/confirm button.
          </Alert>
          <ResponsiveRow
            container
            sx={{
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Container
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", lg: "row" },
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <Typography variant="h6" component="h6">
                Beginning Balance: {formatCurrency(begBalance)}
              </Typography>
              <Typography variant="h6" component="h6">
                Ending Balance: {formatCurrency(endBalance)}
              </Typography>
              <Typography variant="h6" component="h6">
                Cleared Balance: {formatCurrency(reconBalance)}
              </Typography>
              <Typography variant="h6" component="h6">
                Balance Difference: {formatCurrency(balanceDiff)}
              </Typography>
            </Container>
          </ResponsiveRow>
          <br />

          <MuiDataGrid
            dataGridColumns={bankTransactionColumns}
            dataGridRows={unreconciledTransactions}
            serverPagination={false}
            height="45vh"
            totalRows={unreconciledTransactions?.length}
            currentSelectionModel={selectionModel}
            handleSelectedRows={setSelectionModel}
            loading={props.loading}
            noBoxShadow={true}
          />
        </ResponsiveRow>
      )}

      {step === 3 && (
          <ResponsiveRow container sx={{ height: "auto", justifyContent: "start", paddingBlock: "0px"}}>
            <Alert
                id="reconciliationForm"
                severity="info"
                icon={false}
                sx={{ width: "100%"}}
            >
              Confirm balance and transactions details then click reconcile button.
            </Alert>

            <ResponsiveRow
                container
                sx={{paddingTop: 0, margin: "0 auto", height: "auto", width: "100%"}}
            >
              <DetailsRow
                  sx={{
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    width: "50%",
                  }}
              >
                <DetailsLabel sx={{width: "20%"}}> Bank Account:</DetailsLabel>
                <DetailsText sx={{width: "80%"}}>
                  {" "}
                  {props &&
                      orgBankAccountsList &&
                      orgBankAccountsList[0] &&
                      orgBankAccountsList[0].label}
                </DetailsText>
              </DetailsRow>
              <DetailsContainer
                  sx={{width: "100%", height: "auto", margin: "0 auto"}}
              >
                <DetailsColumn sx={{width: {xs: "100%", lg: "33.3%"}}}>
                  <DetailsRow
                      sx={{
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        width: "100%",
                      }}
                  >
                    <DetailsLabel sx={{width: "100%"}}> Start Date:</DetailsLabel>
                    <DetailsText sx={{width: "100%"}}>
                      {" "}
                      {startDate &&
                          formatDate(startDate)}
                    </DetailsText>
                  </DetailsRow>
                  <DetailsRow
                      sx={{
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        width: "100%",
                      }}
                  >
                    <DetailsLabel sx={{width: "100%"}}>
                      {" "}
                      Statement Date:
                    </DetailsLabel>
                    <DetailsText sx={{width: "100%"}}>
                      {statementDate &&
                          formatDate(statementDate)}
                    </DetailsText>
                  </DetailsRow>
                </DetailsColumn>
                <DetailsColumn sx={{width: {xs: "100%", lg: "33.3%"}}}>
                  <DetailsRow
                      sx={{
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        width: "100%",
                      }}
                  >
                    <DetailsLabel sx={{width: "100%"}}>
                      {" "}
                      Beginning Balance:
                    </DetailsLabel>
                    <DetailsText sx={{width: "100%"}}>
                      {" "}
                      {begBalance &&
                          formatCurrency(begBalance)}
                    </DetailsText>
                  </DetailsRow>
                  <DetailsRow
                      sx={{
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        width: "100%",
                      }}
                  >
                    <DetailsLabel sx={{width: "100%"}}>
                      {" "}
                      Ending Balance:
                    </DetailsLabel>
                    <DetailsText sx={{width: "100%"}}>
                      {" "}
                      {endBalance &&
                          formatCurrency(endBalance)}
                    </DetailsText>
                  </DetailsRow>
                </DetailsColumn>
                <DetailsColumn sx={{width: {xs: "100%", lg: "33.3%"}}}>
                  <DetailsRow
                      sx={{
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        width: "100%",
                      }}
                  >
                    <DetailsLabel sx={{width: "100%"}}>
                      {" "}
                      Cleared Balance:
                    </DetailsLabel>
                    <DetailsText sx={{width: "100%"}}>
                      {" "}
                      { reconBalance &&
                          formatCurrency(reconBalance)}
                    </DetailsText>
                  </DetailsRow>
                  <DetailsRow
                      sx={{
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        width: "100%",
                      }}
                  >
                    <DetailsLabel sx={{width: "100%"}}>
                      {" "}
                      Balance Difference:
                    </DetailsLabel>
                    <DetailsText sx={{width: "100%"}}>
                      {" "}
                      {balanceDiff &&
                          formatCurrency(balanceDiff)}
                    </DetailsText>
                  </DetailsRow>
                </DetailsColumn>
              </DetailsContainer>
            </ResponsiveRow>

            <ResponsiveRow sx={{margin: "20px auto"}}>
              <ResponsiveRow sx={{width: "100%"}}>
                <Typography
                    id="view"
                    width={"100%"}
                    variant="h4"
                    marginBottom="20px"
                    component="h6"
                >
                  Reconciliation Transactions{" "}
                  {isArray(reconciledTransactionDetails)
                      ? `${reconciledTransactionDetails.length} Transactions`
                      : ""}
                </Typography>
              </ResponsiveRow>
              <Divider/>

              <MuiDataGrid
                  dataGridColumns={props.reconciledTransactionDetailsColumns}
                  dataGridRows={reconciledTransactionDetails}
                  serverPagination={true}
                  noBoxShadow={true}
                  noSelection={true}
                  handlePageLoad={props.setPaginationModel}
                  loading={props.loading}
                  height="65vh"
                  totalRows={reconciledTransactionDetailsTotal}
              />
            </ResponsiveRow>
          </ResponsiveRow>
      )}
    </ModalContainerModule>
  );
}
